import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Inject SEO and Open Graph meta tags
const metaTags = [{
  name: 'facebook-domain-verification',
  content: 'hb936dl8rvti29zdk6ib2cazlr9v4u'
}, {
  name: 'description',
  content: 'Pack digital imprimible con libros coloreables en PDF. Acceso digital después de la compra para descargar e imprimir desde cualquier dispositivo.'
}, {
  property: 'og:title',
  content: 'Mega Pack Disney Coloring'
}, {
  property: 'og:description',
  content: 'Pack digital imprimible con libros coloreables en PDF. Acceso digital después de la compra para descargar e imprimir desde cualquier dispositivo.'
}, {
  property: 'og:url',
  content: 'https://disneycoloring.atlasdigitalhub.com/'
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:image',
  content: 'https://cdn.magicpatterns.com/uploads/ovxazyqe6TbNyon72GLS97/MEGA_PACK.png'
}];
metaTags.forEach(tag => {
  const el = document.createElement('meta');
  if (tag.name) el.name = tag.name;
  if (tag.property) el.setAttribute('property', tag.property);
  el.content = tag.content;
  document.head.appendChild(el);
});
const canonical = document.createElement('link');
canonical.rel = 'canonical';
canonical.href = 'https://disneycoloring.atlasdigitalhub.com/';
document.head.appendChild(canonical);
(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', '989000920158429');
(window as any).fbq('track', 'PageView');
// Inject Meta Pixel noscript fallback
const noscript = document.createElement('noscript');
const img = document.createElement('img');
img.height = 1;
img.width = 1;
img.style.display = 'none';
img.src = 'https://www.facebook.com/tr?id=989000920158429&ev=PageView&noscript=1';
noscript.appendChild(img);
document.body.appendChild(noscript);
render(<App data-id="element-195" />, document.getElementById('root'));